import {cn} from '@/lib/utils'

export function StepProgress({
  step,
  total,
  label,
  testId,
}: {
  step: number
  total: number
  label: string
  testId?: string
}) {
  return (
    <div data-testid={testId}>
      <p className="font-mono text-[10px] font-medium tracking-wider text-muted-foreground uppercase">{label}</p>
      <div className="mt-2 flex gap-1" aria-hidden="true">
        {Array.from({length: total}, (_, i) => i + 1).map((s) => (
          <span key={s} className={cn('h-1.5 flex-1 rounded-full', s <= step ? 'bg-primary' : 'bg-secondary')} />
        ))}
      </div>
    </div>
  )
}
